import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { useMenuConsultaProduto } from "app/components/menu-consulta-produtos/useMenuConsultaProduto";
import { useMenuSubConsulta } from "app/components/menu-sub-consulta-produto/useMenuSubConsultaProduto";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { EntitesDadosEstoque } from "../../Estoque";
import { Rma } from "./Rma";
import { DadosRma } from "app/api/classes/ProdutoApi";

export type RmaContainerProps = {
  estoqueSelecionado: EntitesDadosEstoque;
  item: IItemOrcamento;
  onRemover: () => void;
  onVoltar: () => void;
  passos: Dict<string, () => void>;
  foraOrcamento: boolean;
};

export const RmaContainer = (props: RmaContainerProps) => {
  const [dados, setDados] = useState<DadosRma[]>([]);

  const isMounted = useRef<boolean>(true);
  useEffect(() => () => { isMounted.current = false; }, []);

  const passosInterno = useRef<Dict<string, () => void>>(
    new Dict(Object.assign({}, props.passos.map))
  );

  const onVoltar = useCallback(() => {
    props.onRemover();
    props.onVoltar();
  }, [props.onRemover, props.onVoltar]);

  const onPassoSelecionado = useCallback((passo: string) => {
    props.onRemover();
    passosInterno.current.get(passo)();
  }, [props.onRemover]);

  const onObterDados = useCallback(async () => {
    try {
      globalMU.blockUI();
      const resposta = await microuniversoApi.Produto.obterDadosRma(
        props.estoqueSelecionado.Codigo,
        props.estoqueSelecionado.Filial,
      );
      if (!isMounted.current) return;
      if (!resposta || resposta.length === 0) {
        globalMU.showWarnMessage('Nenhum registro encontrado.');
      }
      setDados(resposta ?? []);
    } catch (e) {
      if (!isMounted.current) return;
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  }, [props.estoqueSelecionado.Codigo, props.estoqueSelecionado.Filial]);

  useMenuSubConsulta(props);
  useMenuConsultaProduto(
    new Dict(Object.assign({}, props.passos.remove("Estoque do Produto").map)),
    props.onVoltar,
    props.item,
    props.foraOrcamento
  );

  useEffect(() => {
    passosInterno.current.set("Estoque do Produto", () => props.onVoltar());
    passosInterno.current.set("RMA", () => { });
    onObterDados();
  }, []);

  return (
    <div id="RmaContainer">
      <Breadcrumb2Container
        passos={passosInterno.current.keysToList()}
        exibirBotaoLimpar={false}
        exibirBotaoVoltar={true}
        onBotaoVoltarClicado={onVoltar}
        onPassoSelecionado={onPassoSelecionado}
        id="RmaBreadcrumb"
      />
      <br />
      <Rma
        dados={dados}
        produto={props.estoqueSelecionado?.Codigo}
        descricao={props.estoqueSelecionado?.Descricao}
      />
    </div>
  );
};